import React from 'react'
import { Container, Row, Col } from 'react-awesome-styled-grid'

// import CardTestimony from '../components/CardTestimony'
import Phone from '../components/Phone'
import { Section, SectionHeading, SectionContent } from '../components/Section'
import Testimonies from '../components/Testimonies'
import Title from '../components/Title'
// import testimonies from '../mocks/testimonies'

const Testimony = () => (
  <Section
    id="o-que-estao-falando"
    className="duo-section-left texture-light fixed-duo-mobile"
    fluid
    paddingTop={140}
    paddingBottom={80}
  >
    <Container>
      <Row align="center" justify={{ xs: 'center', sm: 'space-between' }}>
        <Col xs={10} sm={6}>
          <SectionHeading>
            <Title
              color="dark"
              appearance="section-texture"
              data-sal="slide-right"
              data-sal-delay="300"
              data-sal-easing="ease"
              data-sal-duration="800"
            >
              <span className="highlight-light">O que estão</span>{' '}
              <span className="highlight-light">falando do</span>{' '}
              <span className="highlight-light">módulo</span>{' '}
              <span className="highlight-light">carne de sol</span>{' '}
              <span className="highlight-light">por aí.</span>
            </Title>
            <div
              data-sal="zoom-in"
              data-sal-delay="400"
              data-sal-easing="ease"
              data-sal-duration="400"
            >
              <Phone />
            </div>
          </SectionHeading>
        </Col>
        <Col xs={12} sm={5}>
          <SectionContent>
            <Testimonies
              data-sal="slide-left"
              data-sal-delay="500"
              data-sal-easing="ease"
              data-sal-duration="800"
            />
            {/* {testimonies.map(({ name, body, date }, i) => (
              <CardTestimony
                key={i}
                name={name}
                body={body}
                date={date}
                data-sal="slide-left"
                data-sal-delay="500"
                data-sal-easing="ease"
                data-sal-duration="800"
              />
            ))} */}
          </SectionContent>
        </Col>
      </Row>
    </Container>
  </Section>
)

export default Testimony
